import type { KambiBetOffer, KambiEvent } from '@mobi/api-types/kambi'
import { simpleFetch } from '@core/Utils/fetch/simpleFetch'

export const getKambiBetOffersByIds = ({ betOfferIds }: { betOfferIds: number[] }) =>
  simpleFetch<KambiBetOffersByIdsResponse>(
    `${window._kc.apiOfferingBaseUrl}betoffer/${betOfferIds.join(',')}`
  )

// =====
// Types
// =====

type KambiBetOffersByIdsResponse = {
  betOffers: KambiBetOffer[]
  events: KambiEvent[]
  /** Represents a pre pack @todo determine if required */
  prePacks: never
  range: {
    start: number
    size: number
    total: number
    hasNext: boolean
  }
}
